module.exports = __webpack_public_path__ + "img/code.d8757aab.jpg";